import {Pagination} from '@mantine/core';
import classes from './pagination.module.css';

export const PaginationTheme = Pagination.extend({
  classNames: {
    control: classes.control,
  },
});